import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import _ from "lodash";
import {VisSkjermedeElementerDialog} from "../../modale/visSkjermedeElementerDialog/visSkjermedeElementerDialog";
import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";

const css = require('./skjermetTips.scss');

export class SkjermetTips implements IController {

    static skjultTipsRegister: { [møteId: string]: boolean } = {};

    static registrerKomponent(angular: IModule) {
        angular
            .component('wmMoeteSkjermetTips', {
                bindings: {moete: '<', aktivSak: '<'},
                controller: SkjermetTips.forInjisering(),
                template: require('./skjermetTips.html')
            });
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            SkjermetTips
        ]
    }

    constructor(private $mdDialog: angular.material.IDialogService) {
    }

    moete: l.MøteModell; //settes via bindings/$onChanges
    aktivSak: l.AgendaelementModell; //settes via bindings/$onChanges

    tipsVises = false;
    modus: 'ikkeTilgang'|'ikkeTilgangBarn'|'andreIkkeTilgang'|'barnSkjermet';
    erSakAktiv = false;

    visDetaljer() {
        VisSkjermedeElementerDialog.visSkjermedeElementerDialog(this.moete, this.$mdDialog);
    }

    skjuTips() {
       SkjermetTips.skjultTipsRegister[this.moete.id] = true;
    }

    $onChanges(changes: IOnChangesObject) {
        dersomChangesInneholder(changes, 'moete', møte => this.initMøte(møte));
        const sakEndring = changes['aktivSak'];
        if (!sakEndring) return;
        if (!_.isNil(sakEndring.previousValue ) && _.isNil(sakEndring.currentValue ))
            this.nullstillAktivSak();
        else if (!_.isNil(sakEndring.currentValue )) this.initAktivSak(sakEndring.currentValue)
    }

    //hjelpemetoder

    private initMøte(møte: l.MøteModell){
        this.moete = møte;
        this.erSakAktiv = false;
        if (this.aktivSak) this.beregnModus(this.aktivSak.tilgang)
        else this.beregnModus(this.moete.tilgang)
    }

    private initAktivSak(aktivSak: l.AgendaelementModell){
        this.aktivSak = aktivSak;
        this.erSakAktiv = true;
        this.beregnModus(this.aktivSak.tilgang)
    }

    private nullstillAktivSak(){
        this.aktivSak = null;
        this.erSakAktiv = false;
        if (this.moete) this.beregnModus(this.moete.tilgang);
    }

    private beregnModus(tilgang: l.TilgangModell){
        if (tilgang.skjerming.erSkjermetForKallendeBruker) this.modus = 'ikkeTilgang';
        else if (tilgang.skjerming.inneholderBarnSkjermetForKallendeBruker) this.modus = 'ikkeTilgangBarn';
        else if (!_.isEmpty(tilgang.skjerming.skjermedeMedlemmerId)) this.modus = 'andreIkkeTilgang';
        else if (tilgang.skjerming.inneholderSkjermedeBarn) this.modus = 'barnSkjermet';
        else this.modus = null;

        this.tipsVises = this.modus !== null && !SkjermetTips.skjultTipsRegister[this.moete.id];
    }

}
